"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Upper case the first character of an input string.
 */
function upperCaseFirst(input) {
    return input.charAt(0).toUpperCase() + input.substr(1);
}
exports.upperCaseFirst = upperCaseFirst;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/upper-case-first/dist/index.js
// module id = 1233
// module chunks = 0